import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@shared/api/client';

export interface ClaudeModelOption {
  id: string;
  displayName: string;
  note: string;
  /** Esito live del check di validità lato Anthropic (GET /v1/models/{id}). */
  valid: boolean;
  validityError?: string;
}

export interface ClaudeConfigDto {
  activeModel: string;
  updatedAt: string | null;
  updatedBy: string | null;
  options: ClaudeModelOption[];
}

export interface ClaudeUsageDayRow {
  date: string;
  model: string;
  requests: number;
  inputTokens: number;
  outputTokens: number;
  costEstimateCents: number;
}

export interface ClaudeUsageDto {
  days: number;
  pricesUpdatedAt: string;
  totalCostEstimateCents: number;
  rows: ClaudeUsageDayRow[];
}

const CONFIG_QK = ['claude-model-config'] as const;

export function useClaudeModelConfig() {
  return useQuery({
    queryKey: CONFIG_QK,
    queryFn: async () => {
      const res = await apiClient.get<ClaudeConfigDto>('/admin/claude-config');
      return res.data;
    },
  });
}

export function useUpdateClaudeModelConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (model: string) => {
      const res = await apiClient.put<ClaudeConfigDto>('/admin/claude-config', { model });
      return res.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: CONFIG_QK }),
  });
}

export function useClaudeUsage(days = 30) {
  return useQuery({
    queryKey: ['claude-usage', days] as const,
    queryFn: async () => {
      const res = await apiClient.get<ClaudeUsageDto>('/admin/claude-usage', { params: { days } });
      return res.data;
    },
  });
}
